import { render, staticRenderFns } from "./welcome-general.vue?vue&type=template&id=6cefdd18&scoped=true&"
import script from "./welcome-general.vue?vue&type=script&lang=js&"
export * from "./welcome-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cefdd18",
  null
  
)

export default component.exports